import { snConfig } from './sn';
import { ciConfig } from './ci';
import { neConfig } from './ne';

const countryConfigs = {
  sn: snConfig,
  ci: ciConfig,
  ne: neConfig
};

export const getCountryConfig = () => {
  const countryCode = localStorage.getItem('selectedCountryCode') || 'sn';
  return countryConfigs[countryCode] || snConfig;
};

export default countryConfigs;